export default [
  {
    path: '/contractors/list',
    name: 'ContractorList',
    component: () => import('@/views/Contractors/ContractorList.vue')
  },
  {
    path: '/contractors/update/:id',
    name: 'ContractorUpdate',
    component: () => import('@/views/Contractors/ContractorUpdate.vue')
  },
  {
    path: '/contractors/status',
    name: 'ContractorsStatusList',
    component: () => import('@/views/Contractors/ContractorsStatusList.vue')
  },
  {
    path: '/contractors/types',
    name: 'ContractorsTypeList',
    component: () => import('@/views/Contractors/ContractorsTypeList.vue')
  },
  {
    path: '/contractors/forms',
    name: 'ContractorsFormList',
    component: () => import('@/views/Contractors/ContractorsFormList.vue')
  }
]
